import { useState, useEffect } from "react";
import { useGetChartOfAccounts } from "../../../../hooks/api/queries";
import { getUrlQuerysection } from "../../../../helpers";
import { useSearchParams } from "react-router-dom";

const useChartOfAccount = () => {
  const [showAddCredit, setShowAddCredit] = useState(false);
  const [showAddDebit, setShowAddDebit] = useState(false);
  const [fundsMovement, setFundsMovement] = useState(null);
  const [isDownloadStatement, setIsDownloadStatement] = useState(false);
  const [showAddBankAccount, setShowAddBankAccount] = useState(false);
  const [showAddChartAccount, setShowAddChartAccount] = useState(false);
  const queries = getUrlQuerysection();

  const {
    isLoading: isLoadingAccountsList,
    data: accountsList,
    refetch: handleFetchAccountsList,
  } = useGetChartOfAccounts({ queries });

  const [search, setSearch] = useSearchParams();

  const gotoPage = (pageNumber) => {
    search.set("page", pageNumber);
    setSearch(search, { replace: true });
  };

  const filterBySearch = (value) => {
    if (value?.length === 0) search.delete("query");
    else search.set("query", value);
    search.delete("page");
    setSearch(search, { replace: true });
  };

  const filterByAccountType = (value) => {
    if (value?.length === 0 || !value) search.delete("account_type");
    else search.set("account_type", value);
    search.delete("page");
    setSearch(search, { replace: true });
  };

  useEffect(() => {
    handleFetchAccountsList();
  }, [search, setSearch]);

  return {
    metaDetails: accountsList?.meta,
    accountsList: accountsList?.data,
    isLoadingAccountsList,
    showAddCredit,
    setShowAddCredit,
    showAddDebit,
    setShowAddDebit,
    fundsMovement,
    setFundsMovement,
    gotoPage,
    isDownloadStatement,
    setIsDownloadStatement,
    handleFetchAccountsList,
    showAddBankAccount,
    setShowAddBankAccount,
    showAddChartAccount,
    setShowAddChartAccount,
    search,
    filterBySearch,
    filterByAccountType,
  };
};

export default useChartOfAccount;
